import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import { axiosapi } from '../api/axiosapi';
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
const BookingModal = (props) => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [formData, setformData] = useState(props.newBooking.seats);
  const [email, setemail] = useState('');
  const [mobileNumber, setmobileNumber] = useState('');

  const handleChange = (event, index) => {
    let data = [...formData];
    data[index][event.target.name] = event.target.value
    setformData(data);

  }
  const bookingamount = props.newBooking.seats.reduce((a, c) => a + c.seatPrice, 0)

  const handleProceedTobook = async () => {
    props.addContactDetails(email, mobileNumber)
    props.updateSeatWithPerson(formData)

    /* const createBookingArray = {
       busId: props.newBooking.bus_id,
       boardingPoint: props.newBooking.boardingPoint,
       droppingPoint: props.newBooking.droppingPoint,
       seats: formData,
       bookedFor: props.journeyDetails.dateofJourney,
       userId: props.userid,
       routeId: props.newBooking.routeId,
       mobileNumber: mobileNumber,
       email: email,
       amount: bookingamount
 
     }
     const response = await axiosPrivate.post('/booking', createBookingArray, { credentials: "include" });
     console.log(response.data)
     if (response.data.success) {
       navigate(`/mybooking/${response.data.booking._id}`) 
  }
 */
    navigate('/checkout')



  }


  return ReactDOM.createPortal(
    <>
      <div className=" fixed top-0 left-0 bottom-0 right-0 bg-[rgba(0,0,0,0.75)]" >
        <div className="lg:w-[38rem] w-[24rem] h-[100%] bg-[#FFF] absolute top-0 right-0 pl-5 pr-5 overflow-y-scroll">
          <div className="flex items-center  text-xl  mt-5 sticky top-0 mb-5">
            <HiOutlineArrowNarrowLeft className="h-6 w-6 cursor-pointer" onClick={() => props.on(false)} />
            <p className="lg:ml-40 font-bold ">Passenger Details</p>

          </div>
          <p className="font-semibold">Passenger Information</p>

          {formData.map((x, index) => (
            <div className="flex flex-col  px-2 py-2 mb-6 gap-3 mt-3 border rounded-sm border-gray-400">
              <p className="text-sm text-gray-400">Passenger {index + 1},  <span className="text-sm font-semibold">Seat {x.seatNumber}</span> </p>
              <div className="flex flex-col  gap-2">
                <p className="text-sm text-gray-400">Name</p>
                <input className="border border-black-200 p-1 rounded-sm outline-none" name="passengername" placeholder="Name" onChange={(e) => handleChange(e, index)} />
              </div>
              <div className="flex justify-between">
                <div><p className=" text-sm text-gray-400 mb-2">Gender</p>
                  <div className="flex  items-center gap-3 "><input type="radio" value="Male" name="passengergender" onChange={(e) => handleChange(e, index)} />Male
                    <input type="radio" value="Female" name="passengergender" onChange={(e) => handleChange(e, index)} />Female</div>

                </div>
                <div>
                  <p className="text-sm text-gray-400 mb-2 ">Age</p>
                  <input onChange={(e) => handleChange(e, index)} type="text" name="passengerage" className="border w-20 border-gray-200 p-1 rounded-sm outline-none" placeholder="Age" />
                </div>

              </div>
            </div>
          ))}
          <p className="font-semibold">Contact Details</p>
          <div className="flex-col flex mt-2 gap-5">
            <div>
              <p className="text-sm text-gray-500 mb-1">Email ID</p>
              <input value={email} onChange={(e) => setemail(e.target.value)} type="email" className=" w-[100%] border border-gray-400 p-1 rounded-sm outline-none" placeholder="email" />
            </div>
            <div>
              <p className="text-sm text-gray-500 mb-1">Phone Number</p>
              <input value={mobileNumber} onChange={(e) => setmobileNumber(e.target.value)} type="text" className="w-[100%] border border-gray-400 p-1 rounded-sm outline-none" placeholder="phone number" />
            </div>

          </div>

          <div className="flex items-center justify-between sticky bottom-0 bg-[#fff] pb-8 pt-8">
            <p className="font-semibold" >Total Amount :    INR  {bookingamount}</p>
            <p className="bg-blue-400  px-2 py-2 text-white font-semibold cursor-pointer" onClick={() => handleProceedTobook()}>Proceed To Pay</p>
          </div>
        </div>

      </div>
    </>,
    document.getElementById('portals')
  )
};

export default BookingModal;
